import type { BoxProps, InlineGridProps } from '@shopify/polaris';
import type { FC } from 'react';

import { BOX_BORDER_INLINE, BOX_PADDING, GRID_COLUMNS } from '../configs';
import { Box, InlineGrid } from '@shopify/polaris';

interface IPVTableComponent extends FC<InlineGridProps> {
  Cell: FC<IPVTableCellProps>;
}

export type IPVTableCellProps = BoxProps;
export const PVTableCell: FC<IPVTableCellProps> = (props) => {
  return <Box {...BOX_PADDING['CELL']} {...props} />;
};

export const PVTable: IPVTableComponent = (props) => {
  return <InlineGrid alignItems="center" {...props} />;
};

PVTable.Cell = PVTableCell;

// Table Price and New Price
export const PVTablePrice: FC<InlineGridProps> = (props) => {
  return (
    <Box minHeight="100%" {...BOX_BORDER_INLINE}>
      <InlineGrid alignItems="center" columns={GRID_COLUMNS['PRICE_GROUP']} {...props} />
    </Box>
  );
};

export const PVTableNewPrice: FC<InlineGridProps> = (props) => {
  return <InlineGrid alignItems="center" columns={GRID_COLUMNS['NEW_PRICE_GROUP']} {...props} />;
};
